import { type Components, type Theme } from '@mui/material';

export const MuiDialog: Components<Theme>['MuiDialog'] = {
  styleOverrides: {
    paper: ({ theme }) => ({
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        alignSelf: 'flex-end',
        height: 'calc(100vh - 65px)',
        margin: 0,
        width: '100%',
        borderRadius: 0,
      },
    }),
  },
};
